import React from 'react'
import Chart from 'react-apexcharts'
import ChartCard from './ChartCard'
import { formatCurrency } from '../mockData'

export default function RevenueExpenseBarChart({ data }) {
    const resultado = data.receitas.map(
        (r, i) => r - data.despesas[i]
    )

    const options = {
        chart: {
            type: 'bar',
            toolbar: { show: false },
            animations: { enabled: true, easing: 'easeinout', speed: 800 },
        },
        plotOptions: {
            bar: {
                columnWidth: '55%',
                borderRadius: 4,
            },
        },
        xaxis: {
            categories: data.categories,
            labels: { style: { colors: '#64748B', fontSize: '11px' } },
        },
        yaxis: {
            labels: {
                style: { colors: '#64748B', fontSize: '12px' },
                formatter: (val) => `R$ ${(val / 1000).toFixed(0)}k`,
            },
        },
        stroke: {
            width: [0, 0, 3],
            curve: 'smooth',
        },
        colors: ['#22C55E', '#EF4444', '#3B82F6'],
        legend: {
            position: 'top',
            horizontalAlign: 'right',
            labels: { colors: '#64748B' },
        },
        tooltip: {
            theme: 'light',
            y: { formatter: (val) => formatCurrency(val) },
        },
        grid: {
            borderColor: '#E2E8F0',
            strokeDashArray: 4,
        },
        dataLabels: { enabled: false },
    }

    const series = [
        { name: 'Receitas', type: 'bar', data: data.receitas },
        { name: 'Despesas', type: 'bar', data: data.despesas },
        { name: 'Resultado', type: 'line', data: resultado },
    ]

    return (
        <ChartCard title="Receitas vs. Despesas" subtitle="Comparativo mensal com resultado líquido">
            <Chart options={options} series={series} type="line" height={320} />
        </ChartCard>
    )
}
